import React, { Component } from 'react';

import Presenter from '../../../presenter.js';
import Request from '../../request.props.js';

import RemainderWorkRow from './RemainderWorkRow.js';
import windowStop from '../../../../utils/windowStop.js';

export default class RemainderWorkList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      rowElement: '',
      dataArray: '',
      count: '',
      isLoading: 'loading',
    }

    this.tmpAlias = null;
    this.onReadWork    = this.onReadWork.bind(this)
    this.onReadSuccess = this.onReadSuccess.bind(this)
    this.onReadFailed  = this.onReadFailed.bind(this)
  }

  generateRow(row) {
   var element = row.map((val, index) => {
      return (
        <RemainderWorkRow 
          RowData={val}
          key={val.Alias}
          openModalEdit = {this.props.openModalEdit}
        />
      )
    })
    return element;
  }

  onReadWork() {
    Presenter.ReadByWork(
      Request.ReadByWork('Read', this, this.onReadSuccess, this.onReadFailed)
    )
  }

  onReadSuccess(params, response){
    this.setState({
      isLoading: 'success',
      count: response.data.count,
      dataArray: response.data.results,
      rowElement: this.generateRow(response.data.results)
    })
  }

  onReadFailed(response){
    this.setState({
      isLoading: 'failed',
    });
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.newData !== null) { 
      if(nextProps.newData.Alias !== this.tmpAlias) {
        this.tmpAlias = nextProps.newData.Alias;
        
        // added new elemet of the begining
        this.setState({count: 1})
        let tmp = this.state.dataArray;
        tmp.unshift(nextProps.newData); 

        /*this.state.rowElement = this.generateRow(tmp)*/
        this.setState({rowElement : this.generateRow(tmp) })
      }
    }

    if(nextProps.update) {
      this.onReadWork();
      this.props.updateRow(false)
    }
  }

  componentDidMount() {
    this.onReadWork();
  }

  componentWillUnmount() {
    windowStop()
  }

  render() { 
    const {isLoading, count} = this.state;

    let dataRow= null;

    if(isLoading === 'loading') {
      dataRow = <tr><td className="table-loading-inside" colSpan="100%">Loading data . . .</td></tr>;

    } else if(isLoading === 'success' && count === 0) {
      dataRow = <tr><td className="table-not-found" colSpan="100%"><span className="icon-drawer"></span>&nbsp;data empty</td></tr>;

    } else if (isLoading === 'success' && count >= 0) {
      dataRow = this.state.rowElement;

    } else if(isLoading === 'failed') {
      dataRow = <tr><td className="table-loading-inside" colSpan="100%">Failed load data</td></tr>;

    } else {
      dataRow = <tr><td className="table-loading-inside" colSpan="100%">Something went wrong</td></tr>;
    }

    return (
      <table className="table table-responsive table-hover table-outline mb-0 m-top-15">
        <thead className="thead-default">
          <tr>
            <th>Method</th>
            <th className="text-center">Email</th>
            <th className="text-center">Mobile</th>
            <th>Time</th>
            <th className="text-center">Edit</th>
          </tr>
        </thead>
        <tbody>
          {dataRow}
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/remainder/helper/component/RemainderWorkList/RemainderWorkList.js